(function() {
  angular.module('admin')
  .controller('editDsoController', ['$uibModalInstance', 'row', '$uibModal', '$scope', 'Dso', '$filter',
    function($uibModalInstance, row, $uibModal,$scope, Dso, $filter) {
      var vm = this;
      vm.dso = angular.copy(row);
      vm.email = vm.dso.email;
      vm.isValidTaxIds = function() {
        if (vm.dso && vm.dso.taxIds && vm.dso.taxIds.length > 0) {
          return !(_.find(_.map(vm.dso.taxIds, function(taxId) { return $filter('taxIdValidationStatus')(taxId.status, taxId);}), function(statusText) {
                  return (!(statusText === 'Valid' || statusText === 'Approved'));
          }));
        }else{
          return false;
        }
      };
      if (vm.dso.status === 'REGISTERED') {
        vm.dsoAuditEventsPromise = Dso.getAuditEvents({id: vm.dso.id}).$promise;
      }
      $scope.$on('authenticationChanged', () => {
        $uibModalInstance.dismiss();
      });
      $scope.$watchCollection('vm.dso.taxIds',(nTaxIds, otaxIds) => {
        vm.taxIdsValidated = vm.isValidTaxIds();
        if (vm.dso.status=='REGISTERED' && !angular.equals(nTaxIds, otaxIds)) {
          vm.taxIdChanged = true;
        }
      });
      //Listen to taxId changes in taxIdGrid. Event 'modal.closing' is issued by $uibModal.
      $scope.$on('modal.closing', function(event, reason, closed) {
        if (!(reason && reason.action)) {
          if (vm.taxIdChanged || vm.locationsFileProcessed) {
              event.preventDefault();
              $uibModalInstance.close({action: 'updateDsoProfile', dso: vm.dso});
          }
        }
      });
      vm.resendRegistrationInvite = function() {
        vm.running = true;
        if (vm.dso.email && vm.email.toLowerCase() == vm.dso.email.toLowerCase()) {
          Dso.sendRegistrationInvite({id: vm.dso.id}, function(data) {
            vm.running = false;
            vm.dso = data;
            $scope.dnConfirmationMessage.$show("Registration invite has been resent.");
          },function() {
            vm.running = false;
          });
        }else{
          $uibModalInstance.close({action: 'updateEmail', dso: vm.dso});
        }
      };
      vm.close = function() {
        $uibModalInstance.dismiss();
      };
      vm.submit = function() {
        $scope.errorControl.showErrors();
        if ($scope.editDsoForm.$valid) {
            $uibModalInstance.close({action: 'approveDso', dso: vm.dso});
        }
      };
      vm.saveDso = function(){
        $scope.errorControl.showErrors();
        if ($scope.editDsoForm.$valid && vm.dso.taxIds.length) {
          $uibModalInstance.close({action: 'saveDso', dso: vm.dso});
        }
      };
      vm.delete = function() {
        $uibModal.open({
          controller:['$uibModalInstance', 'dso', '$scope', function($uibModalInstance, dso, $scope) {
            var self = this;
            self.dso = angular.copy(dso);
            self.delete = function() {
              $scope.errorControl.showErrors();
              if ($scope.deleteForm.$valid) {
                $uibModalInstance.close(true);
              }
            };
            self.close = function() {
              $uibModalInstance.dismiss();
            };
            $scope.$on('authenticationChanged', () => {
              $uibModalInstance.dismiss();
            });
          }],
          templateUrl: '/js/dso/confirmPendingDsoDelete.html' + appVersion,
          size: (vm.dso.status === 'REGISTERED' ? 'md' : 'sm'),
          animation: false,
          controllerAs: 'confirmation',
          resolve: {
            dso: () => vm.dso
          }
        }).result.then(function(val) {
          if (val) {
            $uibModalInstance.close({action: 'deleteDso', dso: vm.dso});
          }
        }, angular.noop);
      };
      vm.addUser = function() {
        $uibModal.open({
          controllerAs: 'vm',
          controller: 'addDsoAdminController',
          templateUrl: '/js/dso/addDsoAdminModal.html' + appVersion,
          size: 'md',
          animation: false,
          resolve: {
            dso: () => vm.dso
          }
        }).result.then(function(res) {
          if (res.add === true) {
            $scope.dnConfirmationMessage.$show("Administrator has been successfully added.");
          }
        }, function() {
          // Cancel
        });
      };
      vm.refreshDsoLocations = function() {
        vm.locationsFileProcessed = true;
        Dso.getDso({id: vm.dso.id},function(dso) {
            vm.dso.documents = dso && dso.documents ? dso.documents : [];
        });
      };
    }]);
})();
